'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../../external/classnames/index.js');

var PropTypes = require('prop-types');

var Button = require('../../../primitives/Button/Button.js');

var index$1 = require('../../../utilities/GatsbyLink/index.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var FeaturedCarouselItem = function FeaturedCarouselItem(props) {
  var category = props.category,
      className = props.className,
      featuredImage = props.featuredImage,
      href = props.href,
      hidePrimaryButton = props.hidePrimaryButton,
      primaryBtnText = props.primaryBtnText,
      secondBtnText = props.secondBtnText,
      secondBtnLink = props.secondBtnLink,
      subtitle = props.subtitle,
      title = props.title;
  var classes = index['default']('lanl-featured-carousel-item', className);
  var subtitleClasses = index['default']('lanl-featured-carousel-item-subtitle', className, {
    'clipped-subtitle': title.length > 55
  });
  var containerClasses = index['default']('lanl-featured-carousel-item-container', {
    mt100: title.length <= 55,
    mt55: title.length > 55
  });
  var FeaturedImage = {
    backgroundImage: "url(".concat(featuredImage, ")")
  };

  var renderSecondBtn = function renderSecondBtn() {
    return secondBtnText && secondBtnLink && /*#__PURE__*/React__default['default'].createElement(Button.Button, {
      arrow: false,
      color: "white",
      className: "lanl-featured-carousel-item-btn lanl-featured-carousel-item-btn-more",
      href: secondBtnLink,
      outline: true
    }, secondBtnText);
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes,
    "data-testid": "lanl-featured-carousel-item",
    style: FeaturedImage
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: containerClasses
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "lanl-featured-carousel-item-content"
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: "lanl-featured-carousel-item-category"
  }, category), /*#__PURE__*/React__default['default'].createElement("h1", {
    className: "lanl-featured-carousel-item-title"
  }, /*#__PURE__*/React__default['default'].createElement(index$1['default'], {
    className: "text-white",
    href: href
  }, title)), /*#__PURE__*/React__default['default'].createElement("p", {
    className: subtitleClasses
  }, subtitle), !hidePrimaryButton && /*#__PURE__*/React__default['default'].createElement(Button.Button, {
    className: "lanl-featured-carousel-item-btn",
    href: href
  }, primaryBtnText, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "sr-only"
  }, "about the article: ", title)), renderSecondBtn())));
};

FeaturedCarouselItem.defaultProps = {
  primaryBtnText: 'Read Story'
};
FeaturedCarouselItem.propTypes = {
  category: PropTypes__default['default'].string.isRequired,
  featuredImage: PropTypes__default['default'].string.isRequired,
  href: PropTypes__default['default'].string.isRequired,
  subtitle: PropTypes__default['default'].string.isRequired,
  title: PropTypes__default['default'].string.isRequired,
  className: PropTypes__default['default'].string,
  hidePrimaryButton: PropTypes__default['default'].bool,
  primaryBtnText: PropTypes__default['default'].string,
  secondBtnLink: PropTypes__default['default'].string,
  secondBtnText: PropTypes__default['default'].string
};
exports.FeaturedCarouselItem = FeaturedCarouselItem;
exports['default'] = FeaturedCarouselItem;